<template>
<div>
    <label class="btn btn-default">
      <input type="file" ref="file" @change="selectFile" />
    </label>

    <button class="btn btn-success" :disabled="!selectedFiles" @click="upload"
      style="marginLeft: -30px">
      Upload
    </button>

    <div v-if="currentFile" class="progress" style="width: 200px">
      <div
        class="progress-bar progress-bar-info progress-bar-striped"
        role="progressbar"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="{ width: progress + '%' }"
      >
        {{ progress }}%
      </div>
    </div>

  </div>
</template>

<script>
import UploadService from '../services/UploadFilesService';

export default {
  name: 'upload-files',
  mounted() {
    const response = UploadService.getFiles();
    this.fileInfos = response;
  },
  methods: {
    upload() {
      this.progress = 0;

      this.currentFile = this.selectedFiles.item(0);
      UploadService.upload(this.currentFile, (event) => {
        this.progress = Math.round((100 * event.loaded) / event.total);
      })
        .then((response) => {
          this.$emit('scoreresult', response.data.score);
          this.message = response.data.message;
          return UploadService.getFiles();
        })
        .then((files) => {
          this.fileInfos = files.data;
        })
        .catch(() => {
          this.progress = 0;
          this.message = 'Could not upload the file!';
          this.currentFile = undefined;
        });

      this.selectedFiles = undefined;
    },
    selectFile() {
      this.selectedFiles = this.$refs.file.files;
    },
  },
  data() {
    return {
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: '',

      fileInfos: [],
    };
  },
};
</script>
